import { Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, TemplateRef, ViewChild, } from '@angular/core';
import { EvsErr } from '../evsErr';
import { EvsStampService } from '../../../../common/services/EvsStamp.service';
import { ConfirmationService } from 'primeng/primeng';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { Router } from '@angular/router';

import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { IOption } from 'ng-select';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { BatchstampService } from '../../qrcode/batchstamp/batchstamp.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { CustomerService } from '../../qrcode/customer/customer.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BatchService } from '../../qrcode/batchstamp/batch.service';
import { BusinessService } from '../../../../common/services/Business.service';
import * as moment from 'moment';
import { ImageService } from '../../../imageService';
import { UploadService } from '../../../../common/services/Upload.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'evs-activate-stamp-for-guarantee',
  templateUrl: 'active-guarantee.template.html',
  styleUrls: ['active-guarantee.template.css'],
  providers: [
    EvsStampService,
    EvsProductService,
    BatchstampService,
    EvsAddressService,
    ConfirmationService,
    BusinessService,
  ],
})
export class ActiveGuaranteeComponent implements OnInit, OnDestroy {
  isComfirm: Boolean = false;
  @ViewChild('smModal') smModal: ModalDirective;
  @ViewChild('template') template: TemplateRef<any>;

  modalRef: BsModalRef;
  modalRefCustomer: BsModalRef;
  @Output('backToList') backToList: any = new EventEmitter();
  title: string = this.translate.instant('KICH_HOAT_BAO_HANH');
  public message: any = { content: false, class: '' };
  dataCheckStamp: any = {};
  stamp_info: any = {};

  public activateStampGuaranteeForm: FormGroup;
  formUpdateCustomer: FormGroup;
  list_store: Array<IOption> = [];
  check_list_store = [];
  list_districtActive: Array<IOption> = [];
  // list_districtRecieve: Array<IOption> = [];
  // list_districtChange: Array<IOption> = [];
  list_city: Array<IOption> = [];
  type: any = [this.translate.instant('KICH_HOAT_TONG_HOP'), this.translate.instant('TIEP_NHAN_TONG_HOP')];
  // select_type: any;
  @Input('serial_input') serial_input: string = '';
  _serial: any;
  address: any = null;
  city: any = null;
  district: any = null;
  email: any = null;
  name: any = null;
  phone: any = null;
  store_id: any = null;
  serial: any = null;
  return_time: any = null;

  // listCustomer: any = [];
  // customer_id: any = 0;
  disabled: Boolean = true;
  // changeInfo: any = 'receive';
  status: any = 0;
  haveCustomer: boolean = false;
  infoActive: any = {};
  infoReceive: any = {};
  infoChange: any = {};
  storeID: any;
  g_return_time: any;
  isFast: Boolean = false;
  isReceive: Boolean = false;
  isActive: boolean = false;

  isActiving: Boolean = false;
  isReceiveing: Boolean = false;
  isChanging: Boolean = false;
  subcribe: Subscription = null;

  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  activated: boolean = false;
  showBody: boolean = false;
  customer: any = {};
  receivening: boolean = false;
  // statusGua: any;
  notHaveGuaranteeService: boolean = false;
  wrongFomatSerial: boolean = false;
  isRestore: boolean = false;
  isShowUpdateInfo: boolean = false;

  fields_list: any = [];
  form_control_fields: any = {};
  FormGuarantee: FormGroup;
  selectedStore: any;
  print: boolean = true;
  log: any = {};
  images: any = [];
  imagesFields: any = {};
  displayBasic: boolean = false;

  productId: any = null;
  productVariant: any;

  loadingSubmitGuarantee: boolean = false;
  listField;
  typeField = {};
  typeName = {};
  cusomerUpdate = {};
  listRequire = [];

  constructor(
    private stampService: EvsStampService,
    private addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private batchService: BatchService,
    private fb: FormBuilder,
    private businessService: BusinessService,
    private router: Router,
    private imageService: ImageService,
    private upload: UploadService,
    private productService: EvsProductService,
    private zone: NgZone,
    private translate: TranslateService
  ) {
    // this.selectedStoreId = [this.check_list_store[0]]
  }

  ngOnInit() {
    // this.smModal.onHide.subscribe((reason: string) => {
    //     this.isComfirm = false
    // });
    this.subcribe = this.modalService.onHide.subscribe((reason: string) => {
      this.isComfirm = false;
    });
    this.getListStore();
    //this.createForm();

    $('[data-toggle="tooltip"]').tooltip();

    this.getListCity();

    this.createFormControls();
    this.createForm();

    this.getListFields();
    setTimeout(() => {
      $('#store-guarantee').select2({
        placeholder: this.translate.instant('CHON_DIEM_BAO_HANH'),
        allowClear: false,
      });
    }, 0);

    this.translate.onLangChange.subscribe(() => {
      setTimeout(() => {
        $('#store-guarantee').select2({
          placeholder: this.translate.instant('CHON_DIEM_BAO_HANH'),
          allowClear: false,
        });
        $('#store-guarantee').val(this.selectedStoreId).trigger('change');
      }, 0);
    });

  }

  getListFields() {
    const code = this.serial_input;
    console.log('codecodecodecode', code)
    this.stampService
      .getFieldGuarantee3(code)
      .toPromise()
      .then((res: any) => {
        if (!res.error) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].keyView = this.formatKey(res.data[i].key);

            if (res.data[i].status) {
              this.fields_list.push(res.data[i]);
            }
          }
          this.createFormGuarantee(this.fields_list);
        } else {
          console.log('getListFields:error', res);
        }
      })
      .catch((err: any) => {
        console.log('getFieldGuarantee:catch', err);
      });
  }

  createFormGuarantee(list?: any) {
    let controls = {
      store_id: [null, Validators.required],
      print: [true],
    };

    for (let field of list) {
      if (field.type == 'checkbox') {
        /*XU ly checkbox*/
        controls[field.key] = this.buildFormCheckbox(field.value, field);
      } else {
        controls[field.key] = [
          null,
          field.require ? Validators.required : null,
        ];
      }
    }
    this.form_control_fields = controls;
    this.FormGuarantee = this.fb.group(controls);
  }

  buildFormCheckbox(list_checkboxs, field) {
    let arr: any = [];
    for (let k in list_checkboxs) {
      if (list_checkboxs[k].isVisible) {
        arr.push(this.fb.control(false));
      }
    }
    // console.log(arr);
    return this.fb.array(arr, field.require ? Validators.required : null);
  }

  submitFormGuarantee(form) {
    console.log('formsssss', form)
    let store_id_new = $(`#store-guarantee`).val()
    console.log('this.status', $(`#store-guarantee`).val());

    console.log(form);
    let listKey = Object.keys(form).map((x) => {
      return x;
    });
    let listKeyView = Object.keys(form).map((x) => {
      return this.formatKey(x);
    });

    if (listKey) {
      console.log(listKey);
      let num = 0;
      for (let i = 0; i < listKey.length; i++) {
        let field: any = this.fields_list.find((x) => x.key == listKey[i]);
        console.log(field);
        // if (form.store_id) {
        //   $('#validatestore_id').text('');
        // } else {
        //   $('#validatestore_id').text(this.translate.instant('PHAI_CHON_DIEM_BAO_HANH'));
        //   num++;
        // }
        if (field) {
          // if (field.require) {

          if (field.type == 'checkbox') {
            let h = 0;
            let listValueKey: any = [];
            for (let c = 0; c < form[listKey[i]].length; c++) {
              if (form[listKey[i]][c]) {
                listValueKey.push(field.value_f[c].id);
                h++;
              }
            }
            form[listKey[i]] = listValueKey.toString();
            if (h > 0) {
              $('#validate' + listKeyView[i]).text('');
            } else {
              if (field.require) {

                $('#validate' + listKeyView[i]).text(this.translate.instant('PHAI_CHON_DU_LIEU'));
                num++;
              }
            }
            form[listKey[i]] = form[listKey[i]].toString();
          } else {
            if (this.FormGuarantee.controls[listKey[i]].invalid == true) {
              if (field.require) {

                $('#validate' + listKeyView[i]).text(
                  this.translate.instant('DU_LIEU_KHONG_DE_TRONG')
                );
                num++;
              }
            } else {
              if (field.require) {

                $('#validate' + listKeyView[i]).text('');
              }
            }
          }
          // }
        }
      }
      if (num == 0) {
        let body: any = {};
        body.serial_id = this.serial_input.trim();

        // body.store_id = form.store_id == '' ? null : form.store_id;
        body.store_id = store_id_new ? store_id_new : null;
        body.customer = {};
        if (this.infoReceive.phone) {
          body.customer.phone = this.infoReceive.phone;
        }
        if (this.infoReceive.name) {
          body.customer.name = this.infoReceive.name;
        }
        if (this.infoReceive.email) {
          body.customer.email = this.infoReceive.email;
        }
        if (this.infoReceive.city) {
          body.customer.city = this.infoReceive.city;
        }
        if (this.infoReceive.district) {
          body.customer.district = this.infoReceive.district;
        }
        if (this.infoReceive.address) {
          body.customer.address = this.infoReceive.address;
        }
        body.status = 2;
        delete form.print;

        //convert date
        this.fields_list.map((res2, i) => {
          console.log('body', res2)
          if (res2.type === 'date') {
            if (form[res2.key]) {

              form[res2.key] = new Date(`${form[res2.key].toString().split('GMT')[0]} GMT+0000`)
            }
          }
        })
        // end convert date


        body.fields = form;
        this.isReceive = false;

        body.images = this.images.map((img: any) => img.url);
        // Tuanba: 11-12-2023 : Thêm mã nội bộ khi in phiếu cho doanh nghiệp latexOne
        console.log('body2222', body)
        // return
        this.loadingSubmitGuarantee = true;
        this.stampService
          .logGuarantee(body)
          .toPromise()
          .then((res: any) => {
            if (res.status == 200) {
              this.isFast = false;
              this.isReceive = true;
              this.loadingSubmitGuarantee = false;
              this.toastr.success(this.translate.instant('TIEP_NHAN_BH_THANH_CONG'), '', {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
              });
              if (this.print) {
                const bodyPrintNew = body;
                bodyPrintNew.stamp_info = this.stamp_info
                console.log('bodyPrintNew', bodyPrintNew)
                this.printer(bodyPrintNew);
              } else {
                this.backToList.emit({
                  isBack: false,
                });
              }
            } else {
              EvsErr.evs_err(res, false);
              this.loadingSubmitGuarantee = false;
            }
          })
          .catch((err: any) => {
            this.loadingSubmitGuarantee = false;
            this.toastr.error(err.message, '', {
              timeOut: 5000,
              positionClass: 'toast-bottom-right',
            });
          });
      }
    }
  }

  convertDate(time?) {
    return time.split('T')[0]
  }

  async getDistricNew(city_id: any, district) {
    const a = await this.addressService
      .getDistrict({ city_id: city_id })
      .toPromise()
      .then(async (res: any) => {
        return await res.data.districts.find(
          (x) => {
            if (x.id == district) {
              return x
              // customer.district = x.name;
            }
          }
        );
      });
    console.log('va', a)
    return a.name
  }


  printer(form?) {
    let user = localStorage.getItem('User');
    if (user) {
      let owner = JSON.parse(user);
      this.businessService.getDetailBusinessById(owner.id).subscribe((res) => {
        if (!res.error) {
          let owner_data = res.data;
          if (this.print && owner_data) {
            let now = moment().format('DD/MM/YYYY');
            let store_id_new = $(`#store-guarantee`).val()
            let store = this.list_store.find((x) => x.value == store_id_new);
            this.batchService
              .findStamp(this.serial_input)
              .subscribe(async (res_batch) => {
                if (!res_batch.error) {
                  if (res_batch.data.batch) {
                    let qri = res_batch.data.batch.qri;

                    let popupWinindow;
                    let data_params: any = {};
                    //let url = window.location.origin + '/print?';
                    if (owner_data) {
                      //url += "owner=" + JSON.stringify(owner_data);
                      data_params.owner = owner_data;
                    }
                    if (store) {
                      //url += "&store=" + store['label'];
                      data_params.store = store;
                    }
                    if (form.customer) {
                      let customer_city = this.list_city.find(
                        (x) => x.value == form.customer.city
                      );
                      // let customer_district = this.list_districtActive.find(
                      //   (x) => x.value == form.customer.district
                      // );
                      let customer: any = {};
                      if (form.customer.district && form.customer.city) {
                        customer.district = await this.getDistricNew(form.customer.city, form.customer.district)
                      }
                      customer.name = form.customer.name;
                      customer.phone = form.customer.phone;
                      customer.email = form.customer.email;
                      customer.address = form.customer.address;
                      if (customer_city) {
                        customer.city = customer_city.label;
                      }
                      let stampInfo: any = {};
                      if (form.stamp_info) {
                        stampInfo = form.stamp_info
                      }

                      let data = form;
                      data.customer = customer;
                      data.stampInfo = stampInfo

                      let listFieldData: any = [];
                      let listKey = Object.keys(form.fields).map((x) => {
                        return x;
                      });
                      let listFormData = Object.keys(form.fields).map((x) => {
                        return form.fields[x];
                      });
                      if (listKey) {
                        for (let i = 0; i < listKey.length; i++) {
                          let field: any = this.fields_list.find(
                            (x) => x.key == listKey[i]
                          );
                          if (field) {
                            let item_field: any = {};
                            if (field.type == 'select') {
                              let item = field.value_f.find(
                                (x) => x.id == parseInt(listFormData[i])
                              );
                              item_field.name = field.name;
                              item_field.data = item ? item.value : '';
                            } else if (field.type == 'checkbox') {
                              let textItem = '';
                              let listItemString = listFormData[i].split(',');
                              for (let h = 0; h < listItemString.length; h++) {
                                let item = field.value_f.find(
                                  (x) => x.id == parseInt(listItemString[h])
                                );
                                if (item && !textItem.length) {
                                  textItem += item.value;
                                } else if (item && textItem.length > 0) {
                                  textItem += ', ' + item.value;
                                }
                              }
                              let listDataCheckBox = textItem;
                              item_field.name = field.name;
                              item_field.data = listDataCheckBox;
                            } else {
                              item_field.name = field.name;
                              item_field.data = listFormData[i]
                                ? listFormData[i]
                                : '';
                            }
                            if (item_field.name && item_field.data) {
                              listFieldData.push(item_field);
                            }
                          }
                        }
                      }
                      data.fields = listFieldData;

                      //url += "&data=" + JSON.stringify(data);
                      data_params.data = data;
                    }
                    if (qri) {
                      //url += "&qri=http://qcheck.vn/" + qri;
                      data_params.qri = 'http://qcheck.vn/' + qri;
                    }
                    if (this.dataCheckStamp.product_name) {
                      //url += "&product=" + this.dataCheckStamp.product_name;
                      data_params.product = this.dataCheckStamp.product_name;
                    }
                    //location.href = url;
                    let data_tranfer = JSON.stringify(data_params);
                    console.log('data_tranfer', data_tranfer)
                    this.router.navigate(['/print'], {
                      queryParams: { data: data_tranfer },
                    });
                  }
                }
              });
          }
        }
      });
    }
  }

  clickField(field, datacheckbox?, store?) {
    console.log('wqeqweqwe')
    if (store) {
      $('#validate' + store).text('');
    } else {
      if (field.require) {
        let h = 0;
        if (datacheckbox) {
          for (let i = 0; i < datacheckbox.length; i++) {
            if ($('#mausac-' + i).prop('checked')) {
              h++;
            }
            if ($(`#${field.keyView}-` + i).prop('checked')) {
              h++;
            }
          }
          if (h > 0) {
            $('#validate' + field.keyView).text('');
          } else {
            $('#validate' + field.keyView).text(this.translate.instant('PHAI_CHON_DU_LIEU'));
          }
        } else {
          $('#validate' + field.keyView).text('');
        }
      }
    }
  }

  focusoutField(field, store?) {
    if (store) {
      if (this.selectedStore) {
        $('#validate' + store).text('');
      }
      // else {
      //   $('#validate' + store).text(this.translate.instant('PHAI_CHON_DIEM_BAO_HANH'));
      // }
    } else {
      if (field.require) {
        if ($('#' + field.keyView).val()) {
          $('#validate' + field.keyView).text('');
        } else {
          $('#validate' + field.keyView).text(this.translate.instant('KHONG_DUOC_DE_TRONG'));
        }

        if (field.type == 'date') {
          setTimeout(() => {
            if ($('#' + field.keyView).val()) {
              $('#validate' + field.keyView).text('');
            } else {
              $('#validate' + field.keyView).text(this.translate.instant('KHONG_DUOC_DE_TRONG'));
            }
          }, 200);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.subcribe) {
      this.subcribe.unsubscribe();
    }
  }

  createFormControls() {
    this._serial = new FormControl('');
  }

  createForm() {
    this.activateStampGuaranteeForm = new FormGroup({
      serial: this._serial,
    });
  }

  focusSerial() {
    this.wrongFomatSerial = false;
  }


  checkSerial() {
    this.serial_input = this.activateStampGuaranteeForm.value.serial;
    this.status = 0;
    this.activated = false;
    this.haveCustomer = false;
    this.receivening = false;
    this.notHaveGuaranteeService = false;
    this.wrongFomatSerial = false;
    this.isRestore = false;
    this.showBody = false;
    this.dataCheckStamp = {};
    this.stamp_info = {}
    let code: string = this.serial_input.trim();
    if (code.length > 0) {
      // let stringList = code.split('-');
      // if (stringList.length < 2) {
      //   this.wrongFomatSerial = true;
      //   this.status = 0;
      // } else {
      //   var reg = new RegExp('^[0-9]+$');
      //   let _number = stringList.pop();
      //   let testString = reg.test(_number);
      //   if (!testString) {
      //     this.wrongFomatSerial = true;
      //     this.status = 0;
      //   } else {
      //     this.wrongFomatSerial = false;
      this.findCode(code);
      // }
      // }
    } else {
      this.showBody = false;
    }
  }

  listStampInBox: any = [];
  typeStamp: any = undefined; // 0: tem sp, 1: tem thùng
  statusBoxStamp: any = undefined;// 0: tem sp, 1: tem thùng
  isActiveInfoStamp: Boolean = false;
  isTabActiveStamp: Boolean = true;
  flagCheckStoreList = 0;

  findCode(code) {
    setTimeout(() => {
      $('#store-guarantee').select2({
        placeholder: this.translate.instant('CHON_DIEM_BAO_HANH'),
        allowClear: false,
      });
    }, 0)

    console.log(123123);
    this.selectedStore = '';
    if (this.FormGuarantee) {
      this.FormGuarantee.controls.store_id.setValue('');
      $(`#store-guarantee`).val('');
    }

    // const storeGuarantee = $('#store-guarantee');
    // setTimeout(() => {
    //   storeGuarantee.select2({placeholder: 'Chọn cua hang', allowClear: true})
    // }, 0)
    console.log('123123123', this.selectedStore)
    this.dataCheckStamp = {};
    this.list_districtActive = [];
    console.log('this.list_districtActive', this.list_districtActive);
    this.stampService
      .getInfoStamp(code)
      .toPromise()
      .then((res: any) => {
        if (res.data) {
          if (res.data.stamp_info) {
            this.stamp_info = res.data.stamp_info
          }
          console.log('this.stamp_info ', this.stamp_info)
          if (res.data.guarantee_info) {
            this.dataCheckStamp.expired_time =
              res.data.guarantee_info.expired_time;
            this.dataCheckStamp.produce_time =
              res.data.guarantee_info.produce_time;
            this.dataCheckStamp.product_image = this.imageService.readSrcImage(
              res.data.guarantee_info.product_image,
              'thumb_medium'
            );
            this.dataCheckStamp.product_name =
              res.data.guarantee_info.product_name;
            this.dataCheckStamp.product_id =
              res.data.guarantee_info.product_id;
            console.log('this.dataCheckStamp', this.dataCheckStamp)

            // get list variant
            if (res.data.guarantee_info.product_id) {
              this.hasVariants(res.data.guarantee_info.product_id).then(
                (res) => {
                  this.hasVariant = res;
                }
              );
              this.productId = res.data.guarantee_info.product_id;
            }
          }
          if (res.data.last_guarantee) {
            this.stampService
              .getLogGuaranteeById(res.data.last_guarantee._id)
              .subscribe((res_gua) => {
                if (!res_gua.error) {
                  let log = res_gua.data.logs;
                  let has_state = log.state && log.state.id && log.state.id > 0;
                  if (log.fields) {
                    for (let i = 0; i < log.fields.length; i++) {
                      if (log.fields[i].value) {
                        let stringValue: any;
                        if (typeof log.fields[i].value == 'string') {
                          stringValue = log.fields[i].value.split('\n');
                        } else {
                          stringValue = log.fields[i].value;
                        }

                        if (stringValue.length > 1) {
                          let listText: any = [];
                          for (let h = 0; h < stringValue.length; h++) {
                            listText.push(stringValue[h]);
                          }
                          log.fields[i]['haveEnter'] = true;
                          log.fields[i].value = listText;
                        }
                      }
                    }
                  }
                  let obj = {
                    id: log._id,
                    created_time: log.created_time,
                    created_time_f: moment(log.created_time).format(
                      'DD/MM/YYYY'
                    ),
                    updated_time: log.updated_time,
                    updated_time_f: moment(log.updated_time).format(
                      'DD/MM/YYYY'
                    ),
                    customer: log.customer,
                    user_created: log.user_created,
                    note: log.note,
                    status: log.status.id,
                    status_f: log.status.name,
                    state: has_state ? log.state.id : null,
                    state_f: has_state ? log.state.name : null,
                    is_active: log.status.id == 1,
                    is_receive: log.status.id == 5,
                    is_wait: log.status.id == 2 && log.state.id == 6,
                    is_reject: log.status.id == 2 && log.state.id == 4,
                    is_done: log.status.id == 2 && log.state.id == 3,
                    fields: log.fields,
                  };
                  this.log = obj;
                }
              });
          }
          console.log(123123, res.data.code);

          if (!res.data.code && res.data.code !== 0) {
            this.activated = true;
            this.showBody = true;
            this.haveCustomer = true;

            this.infoActive.phone = res.data.customer.phone;
            this.infoActive.name = res.data.customer.name;
            this.infoActive.email = res.data.customer.email;
            this.infoActive.address = res.data.customer.address;
            this.infoActive.fields = res.data.customer.fields;

            this.infoReceive.phone = res.data.customer.phone;
            this.infoReceive.name = res.data.customer.name;
            this.infoReceive.email = res.data.customer.email;
            this.infoReceive.address = res.data.customer.address;

            this.infoChange.phone = res.data.customer.phone;
            this.infoChange.name = res.data.customer.name;
            this.infoChange.email = res.data.customer.email;
            this.infoChange.address = res.data.customer.address;
            this.infoChange.variant_id = res.data.customer.variant_id;
            this.infoChange.fields = res.data.customer.fields;
            console.log('res.data1', res.data)
            if (res.data.customer.city) {
              this.infoActive.city = res.data.customer.city.toString();
              this.infoReceive.city = res.data.customer.city.toString();
              this.infoChange.city = res.data.customer.city.toString();
              this.getListDistrict(
                res.data.customer.city.toString(),
                res.data.customer.district,
                null
              );
            }
            console.log('this.check_list_store =  all_store', this.check_list_store)
            if (this.check_list_store.length === 1) {
              console.log('this.check_list_store =  all_storeresss',)
              this.getIdCity()
            }

            if (res.data.customer.receivening) {
              this.receivening = true;
              this.showBody = false;
              //this.choiceChange();
              return;
            }
            this.receivening = false;
            this.showBody = true;
            this.choiceReceive();
          } else {
            this.haveCustomer = false;
            this.infoActive = {};
            this.infoReceive = {};
            this.infoChange = {};
            console.log('this.check_list_store =  all_store', this.check_list_store)
            if (this.check_list_store.length === 1) {
              this.getIdCity()
            }
            switch (res.data.code) {
              case 0: {
                this.activated = false;
                this.showBody = true;
                this.haveCustomer = false;
                this.receivening = false;
                this.choiceActive();
                break;
              }
              case 1: {
                this.activated = false;
                this.showBody = true;
                this.haveCustomer = false;
                this.receivening = false;
                this.choiceActive();
                break;
              }
              case 2: {
                this.haveCustomer = false;
                this.activated = true;
                if (res.data.receivening) {
                  this.receivening = true;
                  this.showBody = false;
                  // this.showBody = true;
                } else {
                  this.receivening = false;
                  this.showBody = true;
                }
                this.choiceReceive();
                break;
              }
              case 5: {
                this.showBody = false;
                this.activated = false;
                this.haveCustomer = false;
                this.receivening = false;
                this.isRestore = true;
                this.status = 0;
                $('#serialValidate').text('Serial đã bị khóa');
                break;
              }
            }
          }

          if (res.data.extra) {
            console.log(res.data.extra);
            this.productVariant = res.data.extra;
            this.productVariant.id = this.productVariant.id.toString();
            this.variantId = this.variantId
              ? this.variantId
              : this.productVariant.id.toString();
            this.tmpVariant = this.productVariant;
          }
        }
      })
      .catch((err) => {
        this.showBody = false;
        this.status = 0;
        this.toastr.error(err.message, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      });
    console.log('this.status', this.status);
    this.stampService
      .getListStampInBox({
        serial: code,
        page: 1,
        page_size: 100,
      })
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.listStampInBox = res.data.items.map((gg) => {
            let tmpItem = Object.assign({}, gg);
            tmpItem.serial = this.formatSerialNew(gg.idStart, gg.idEnd, gg.prefix);
            return tmpItem;
          });
          this.typeStamp = res.data.bundleType;
          this.statusBoxStamp = res.data.status;
          console.log('this.statusBoxStamp = res.data.status', this.statusBoxStamp)
          if (this.typeStamp === 1 && this.statusBoxStamp === 1) {
            this.isActiveInfoStamp = true;
            this.isTabActiveStamp = false;
          } else {
            this.isActiveInfoStamp = false;
            this.isTabActiveStamp = true;
          }
        }
      });
  }

  hasVariant: boolean = true;

  hasVariants(productId: any) {
    return this.productService
      .getListVariant(productId)
      .toPromise()
      .then((res) => {
        if (!res.error && res.data.count.count) {
          return true;
        } else {
          return false;
        }
      });
  }

  choiceActive() {
    this.status = 1;
    this.cusomerUpdate = {}
    this.listRequire = []
    this.cusomerUpdate['nameField'] = {}
    this.cusomerUpdate['fields'] = {}
    this.stampService.getFieldGuaranteeCustomes2(this.serial_input).subscribe((res) => {
      if (res.data.length > 0) {
        this.listField = res.data;
        console.log('listField listField', this.listField);
        this.listField.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1 && val.status === 1) {
            this.listRequire.push(val.key)
          }
          this.cusomerUpdate['nameField'][val.key] = val.name

          if (val.type === 'image') {
            this.imagesFields[val.key] = []
            this.cusomerUpdate['fields'][val.key] = []
          }

          if (val.type === 'checkbox') {
            this.cusomerUpdate['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdate['fields'][val.key][`check111${n.id}`] = false
            })
          }
          if (val.type === 'input') {
            this.cusomerUpdate['fields'][val.key] = val.value
          }
          if (val.type === 'date') {
            this.cusomerUpdate['fields'][val.key] = val.value ? moment(val.value).format('DD/MM/YYYY') : null
          }
          if (val.type === 'textarea') {
            this.cusomerUpdate['fields'][val.key] = val.value
          }

          if (this.infoActive.fields && this.infoActive.fields.length > 0 && this.infoActive.fields !== null) {
            console.log('vao day ko ??!23213???')
            this.infoActive.fields.map((item) => {
              if (item.key === val.key) {
                if (val.type === 'date') {
                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdate['fields'][val.key] = {}
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                } else if (val.type === 'image') {
                  this.imagesFields[val.key] = item.string_values
                  // this.cusomerUpdate['fields'][val.key] = item.string_values
                } else {
                  console.log('??asjisjmj')
                  this.cusomerUpdate['fields'][val.key] = item.string_values
                }
              }
            })
          }
        })
      }
      console.log('this.cusomerUpdate', this.cusomerUpdate)
      console.log('this.typeField', this.typeField,)
    });

  }

  choiceReceive() {
    this.status = 2;
    setTimeout(() => {
      $('#g-return-time').datepicker({
        format: 'yyyy-mm-dd',
      });
    }, 20);
  }

  choiceChange() {
    this.status = 5;
  }

  selectTab(value: any) {
    this.infoActive.phone = null;
    this.infoReceive.phone = null;
    this.infoChange.phone = null;
    this.status = value;
  }

  getListStore(province?, district?) {
    if (province && district) {
      this.stampService
        .getAllStore({
          desc: 'id',
          deleted: 0,
          status: 1,
          province: province,
          district: district,
        })
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            let all_store = [];
            for (let p of res.data.store) {
              all_store.push({
                value: p.id,
                label: p.name,
                city_name: p.city_name,
                district_name: p.district_name,
                province: p.province,
                district: p.district
              });
            }
            this.list_store = all_store;
            this.check_list_store = all_store
          } else {
            EvsErr.evs_err(res.message, false);
          }
        })
        .catch((err: any) => {
          EvsErr.evs_err(err.message);
        });
    } else {
      this.stampService
        .getAllStore({ desc: 'id', deleted: 0, status: 1 })
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            let all_store = [];
            for (let p of res.data.store) {
              all_store.push({
                value: p.id,
                label: p.name,
                city_name: p.city_name,
                district_name: p.district_name,
                province: p.province,
                district: p.district
              });
            }
            this.list_store = all_store;
            this.check_list_store = all_store
          } else {
            EvsErr.evs_err(res.message, false);
          }
        })
        .catch((err: any) => {
          EvsErr.evs_err(err.message);
        });
    }
  }

  checkReturn_time() {
    this.return_time = $('#g-return-time').val();
  }

  getListDistrict(city_Id: any, districtID: any, status) {
    console.log('váo ko nhỉ', city_Id, districtID)
    if (city_Id) {
      this.addressService
        .getDistrict({ city_id: city_Id })
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            let districts = [];
            for (let d of res.data.districts) {
              districts.push({ value: d.id.toString(), label: d.name });
            }
            this.list_districtActive = districts;
            if (districtID) {
              if (status) {
                switch (status) {
                  case 1: {
                    this.infoActive.district = districtID.toString();
                    break;
                  }
                  case 2: {
                    this.infoReceive.district = districtID.toString();
                    break;
                  }
                  case 5: {
                    this.infoChange.district = districtID.toString();
                    break;
                  }
                }
              } else {
                this.infoActive.district = districtID.toString();
                this.infoReceive.district = districtID.toString();
                this.infoChange.district = districtID.toString();
              }
            }
          }
        });
    }
  }

  getListCity() {
    this.addressService
      .getCities()
      .toPromise()
      .then((res: any) => {
        if (res.status == 200) {
          let cities = [];
          for (let c of res.data.cities) {
            cities.push({ value: c.id.toString(), label: c.name });
          }
          this.list_city = cities;
          // console.log(this.list_city);
        }
      });
  }

  findCustomerByPhone() {
    console.log(122121212222);
    console.log('this.status', this.status)
    switch (this.status) {
      case 1: {
        if (this.infoActive.phone) {
          if (this.infoActive.phone.length > 0) {
            this.stampService
              .getUserByPhone(this.infoActive.phone)
              .subscribe((res) => {
                if (!res.error) {
                  if (res.data.customer) {
                    var info = res.data.customer;
                    this.toastr.info(
                      this.translate.instant('DA_TAI_VE_THONG_TIN_KHACH') + ' ' +
                      this.infoActive.phone,
                      '',
                      {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right',
                      }
                    );
                    this.infoActive.name = info.name;
                    this.infoActive.email = info.email;
                    this.infoActive.address = info.address;
                    this.infoActive.fields = info.fields;
                    this.cusomerUpdate = {}
                    this.listRequire = []
                    this.cusomerUpdate['nameField'] = {}
                    this.cusomerUpdate['fields'] = {}
                    this.stampService.getFieldGuaranteeCustomes2(this.serial_input).subscribe((res) => {
                      if (res.data.length > 0) {
                        this.listField = res.data;
                        this.listField.map((val) => {
                          this.typeField[val.key] = val.type
                          this.typeName[val.key] = val.name
                          if (val.require === 1 && val.status === 1) {
                            this.listRequire.push(val.key)
                          }
                          this.cusomerUpdate['nameField'][val.key] = val.name

                          if (val.type === 'image') {
                            this.imagesFields[val.key] = []
                            this.cusomerUpdate['fields'][val.key] = []
                          }
                          if (val.type === 'checkbox') {
                            this.cusomerUpdate['fields'][val.key] = {}
                            val.value_f.map((n) => {
                              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
                            })
                          }
                          if (val.type === 'input') {
                            this.cusomerUpdate['fields'][val.key] = val.value
                          }
                          if (val.type === 'date') {
                            this.cusomerUpdate['fields'][val.key] = val.value ? moment(val.value).format('DD/MM/YYYY') : null
                          }
                          if (val.type === 'textarea') {
                            this.cusomerUpdate['fields'][val.key] = val.value
                          }
                          if (this.infoActive.fields && this.infoActive.fields.length > 0 && this.infoActive.fields !== null) {
                            console.log(12222)
                            this.infoActive.fields.map((item) => {
                              if (item.key === val.key) {

                                if (val.type === 'date') {

                                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                                } else if (val.type === 'checkbox') {
                                  this.cusomerUpdate['fields'][val.key] = {}
                                  val.value_f.map((n) => {
                                    if (item.string_values.split(',').includes(String(n.id))) {
                                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                                    }
                                  })
                                } else if (val.type === 'image') {
                                  this.imagesFields[val.key] = item.string_values
                                  // this.cusomerUpdate['fields'][val.key] = item.string_values
                                } else {
                                  this.cusomerUpdate['fields'][val.key] = item.string_values
                                }
                              }

                            })
                          }
                        })
                      }

                    });
                    if (info.city && info.district) {
                      this.infoActive.city = info.city.toString();
                      this.getListDistrict(
                        this.infoActive.city,
                        info.district,
                        1
                      );
                    }
                  }
                }
              });
          }
          console.log('this.kasdasd')
        }
        break;
      }
      case 2: {
        // if (this.infoReceive.phone) {
        //     if (this.infoChange.phone.length > 0) {
        //         this.stampService.getUserByPhone(this.infoReceive.phone)
        //             .subscribe(res => {
        //                 if (!res.error) {
        //                     if (res.data.customer) {
        //                         var info = res.data.customer;
        //                         this.toastr.info(this.translate.instant('DA_TAI_VE_THONG_TIN_KHACH') + ' ' + this.infoReceive.phone, '', {
        //                             timeOut: 4000,
        //                             positionClass: 'toast-bottom-right'
        //                         });
        //                         this.infoReceive.name = info.name;
        //                         this.infoReceive.email = info.email;
        //                         this.infoReceive.address = info.address;
        //                         if (info.city && info.district) {
        //                             this.infoReceive.city = info.city.toString();
        //                             this.getListDistrict(this.infoReceive.city, info.district, 2);
        //                         }
        //                     }
        //                 }
        //             })
        //     }
        // }
        if (this.infoChange.phone) {
          if (this.infoChange.phone.length > 0) {
            this.stampService
              .getUserByPhone(this.infoChange.phone)
              .subscribe((res) => {
                if (!res.error) {
                  if (res.data.customer) {
                    var info = res.data.customer;
                    this.toastr.info(
                      this.translate.instant('DA_TAI_VE_THONG_TIN_KHACH') + ' ' +
                      this.infoChange.phone,
                      '',
                      {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right',
                      }
                    );
                    this.infoChange.name = info.name;
                    this.infoChange.email = info.email;
                    this.infoChange.address = info.address;
                    this.infoChange.fields = info.fields;

                    this.cusomerUpdate = {}
                    this.listRequire = []
                    this.cusomerUpdate['nameField'] = {}
                    this.cusomerUpdate['fields'] = {}
                    this.stampService.getFieldGuaranteeCustomes2(this.serial_input).subscribe((res) => {
                      if (res.data.length > 0) {
                        this.listField = res.data;
                        this.listField.map((val) => {
                          this.typeField[val.key] = val.type
                          this.typeName[val.key] = val.name
                          if (val.require === 1 && val.status === 1) {
                            this.listRequire.push(val.key)
                          }
                          this.cusomerUpdate['nameField'][val.key] = val.name
                          if (val.type === 'image') {
                            this.imagesFields[val.key] = []
                            this.cusomerUpdate['fields'][val.key] = []
                          }
                          if (val.type === 'checkbox') {
                            this.cusomerUpdate['fields'][val.key] = {}
                            val.value_f.map((n) => {
                              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
                            })
                          }
                          if (val.type === 'input') {
                            this.cusomerUpdate['fields'][val.key] = val.value
                          }
                          if (val.type === 'date') {
                            this.cusomerUpdate['fields'][val.key] = val.value ? moment(val.value).format('DD/MM/YYYY') : null
                          }
                          if (val.type === 'textarea') {
                            this.cusomerUpdate['fields'][val.key] = val.value
                          }
                          if (this.infoChange.fields && this.infoChange.fields.length > 0 && this.infoChange.fields !== null) {
                            this.infoChange.fields.map((item) => {
                              if (item.key === val.key) {

                                if (val.type === 'date') {

                                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                                } else if (val.type === 'checkbox') {
                                  this.cusomerUpdate['fields'][val.key] = {}
                                  val.value_f.map((n) => {
                                    if (item.string_values.split(',').includes(String(n.id))) {
                                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                                    }
                                  })
                                } else if (val.type === 'image') {
                                  this.imagesFields[val.key] = item.string_values
                                  // this.cusomerUpdate['fields'][val.key] = item.string_values


                                } else {
                                  this.cusomerUpdate['fields'][val.key] = item.string_values
                                }
                              }

                            })
                            console.log(this.cusomerUpdate)
                          }
                        })
                      }

                    });
                    if (info.city && info.district) {
                      this.infoChange.city = info.city.toString();
                      this.getListDistrict(
                        this.infoChange.city,
                        info.district,
                        5
                      );
                    }
                  }
                }
              });
          }
        }
        break;
      }
      case 5: {
        if (this.infoChange.phone) {
          if (this.infoChange.phone.length > 0) {
            this.stampService
              .getUserByPhone(this.infoChange.phone)
              .subscribe((res) => {
                if (!res.error) {
                  if (res.data.customer) {
                    var info = res.data.customer;
                    this.toastr.info(
                      this.translate.instant('DA_TAI_VE_THONG_TIN_KHACH') + ' ' +
                      this.infoChange.phone,
                      '',
                      {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right',
                      }
                    );
                    this.infoChange.name = info.name;
                    this.infoChange.email = info.email;
                    this.infoChange.address = info.address;
                    this.infoChange.fields = info.fields;
                    this.cusomerUpdate = {}
                    this.listRequire = []
                    this.cusomerUpdate['nameField'] = {}
                    this.cusomerUpdate['fields'] = {}
                    this.stampService.getFieldGuaranteeCustomes2(this.serial_input).subscribe((res) => {
                      if (res.data.length > 0) {
                        this.listField = res.data;
                        this.listField.map((val) => {
                          this.typeField[val.key] = val.type
                          this.typeName[val.key] = val.name
                          if (val.require === 1 && val.status === 1) {
                            this.listRequire.push(val.key)
                          }
                          this.cusomerUpdate['nameField'][val.key] = val.name

                          if (val.type === 'image') {
                            this.imagesFields[val.key] = []
                            this.cusomerUpdate['fields'][val.key] = []
                          }

                          if (val.type === 'checkbox') {
                            this.cusomerUpdate['fields'][val.key] = {}
                            val.value_f.map((n) => {
                              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
                            })
                          }
                          if (val.type === 'input') {
                            this.cusomerUpdate['fields'][val.key] = val.value
                          }
                          if (val.type === 'date') {
                            this.cusomerUpdate['fields'][val.key] = val.value ? moment(val.value).format('DD/MM/YYYY') : null
                          }
                          if (val.type === 'textarea') {
                            this.cusomerUpdate['fields'][val.key] = val.value
                          }
                          if (this.infoChange.fields && this.infoChange.fields.length > 0 && this.infoChange.fields !== null) {
                            console.log(12222)
                            this.infoChange.fields.map((item) => {
                              if (item.key === val.key) {

                                if (val.type === 'date') {

                                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                                } else if (val.type === 'checkbox') {
                                  this.cusomerUpdate['fields'][val.key] = {}
                                  val.value_f.map((n) => {
                                    if (item.string_values.split(',').includes(String(n.id))) {
                                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                                    }
                                  })
                                } else if (val.type === 'image') {
                                  this.imagesFields[val.key] = item.string_values
                                  // this.cusomerUpdate['fields'][val.key] = item.string_values


                                } else {
                                  this.cusomerUpdate['fields'][val.key] = item.string_values
                                }
                              }
                            })
                          }
                        })
                      }
                    });
                    if (info.city && info.district) {
                      this.infoChange.city = info.city.toString();
                      this.getListDistrict(
                        this.infoChange.city,
                        info.district,
                        5
                      );
                    }
                  }
                }
              });
          }
        }
        break;
      }
    }
  }

  excecute() {
    if (this.serial_input.trim().length > 0) {
      // let serials = this.serial_input.trim().split('-');
      // if (serials.length > 1) {
      //   let sNumber = serials[serials.length - 1];
      //   if (sNumber.length < 6) {
      //     this.toastr.error('sai định dạng serial', '', {
      //       timeOut: 4000,
      //       positionClass: 'toast-bottom-right',
      //     });
      //     return
      //   } else {
      this.excecuteGravity();
      //   }
      // } else {
      //   this.toastr.error('sai định dạng serial', '', {
      //     timeOut: 4000,
      //     positionClass: 'toast-bottom-right',
      //   });
      //   return
      //
      // }
    } else {
      this.toastr.warning(this.translate.instant('SERIAL_KHONG_DE_TRONG'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return

    }
  }


  variantId: any;
  tmpVariant: any;

  changeVariant(event) {
    this.variantId = event;
    this.productVariant.id = event;
  }

  changeVariantLabel(event) {
    this.productVariant.extra = event;

    console.log(this.tmpVariant);
  }

  openWarningAtive(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  fastActive() {
    var request: any = {
      customer: {},
    };
    request.status = 1;
    request.serial_id = this.serial_input.trim();
    if (this.infoReceive.phone && this.infoReceive.phone !== '') {
      request.customer.phone = this.infoReceive.phone;
    }
    if (this.infoReceive.name && this.infoReceive.name !== '') {
      request.customer.name = this.infoReceive.name;
    }
    if (this.infoReceive.email && this.infoReceive.email != '') {
      request.customer.email = this.infoReceive.email;
    }
    if (this.infoReceive.address && this.infoReceive.address != '') {
      request.customer.address = this.infoReceive.address;
    }
    if (this.infoReceive.city && this.infoReceive.city != '') {
      request.customer.city = parseInt(this.infoReceive.city);
    }
    if (this.infoReceive.district && this.infoReceive.district != '') {
      request.customer.district = parseInt(this.infoReceive.district);
    }
    if (
      request.customer.phone &&
      request.customer.phone !== '' &&
      request.customer.name &&
      request.customer.name !== ''
    ) {
      this.stampService
        .logGuarantee(request)
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            this.isFast = false;
            this.isReceive = true;
            this.toastr.success(this.translate.instant('KICH_HOAT_BH_THANH_CONG'), '', {
              timeOut: 5000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            EvsErr.evs_err(res, false);
          }
        })
        .catch((err: any) => {
          this.toastr.error(err.message, '', {
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
          });
        });
    }
  }

  closeModelTwo() {
    this.modalRef.hide();
    this.backToList.emit({
      isBack: false,
    });
  }

  closeModal() {
    this.modalRefCustomer.hide();
    if (this.tmpVariant) {
      this.variantId = this.tmpVariant.id;
      this.productVariant.id = this.tmpVariant.id;
      this.productVariant.extra = this.tmpVariant.extra;
      console.log(this.productVariant);
    }
  }

  goToList() {
    this.backToList.emit();
  }

  showUpdateCustomer(template) {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRefCustomer = this.modalService.show(template, config);
    this.formUpdateCustomer = new FormGroup({
      phone: new FormControl(this.infoChange.phone),
      name: new FormControl(this.infoChange.name),
      email: new FormControl(this.infoChange.email),
      city: new FormControl(this.infoChange.city),
      district: new FormControl(this.infoChange.district),
      address: new FormControl(this.infoChange.address),
    });
    console.log('this.infoChange', this.infoChange)
    this.cusomerUpdate = {}
    this.listRequire = []
    this.cusomerUpdate['nameField'] = {}
    this.cusomerUpdate['fields'] = {}
    this.stampService.getFieldGuaranteeCustomes2(this.serial_input).subscribe((res) => {
      if (res.data.length > 0) {
        this.listField = res.data;
        this.listField.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1 && val.status === 1) {
            this.listRequire.push(val.key)
          }
          this.cusomerUpdate['nameField'][val.key] = val.name

          if (val.type === 'image') {
            this.imagesFields[val.key] = []
            console.log('this.imagesFields', this.imagesFields)
            this.cusomerUpdate['fields'][val.key] = []

          }
          if (val.type === 'checkbox') {
            this.cusomerUpdate['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
            })
          }
          if (val.type === 'input') {
            this.cusomerUpdate['fields'][val.key] = val.value
          }
          if (val.type === 'date') {
            this.cusomerUpdate['fields'][val.key] = val.value ? moment(val.value).format('DD/MM/YYYY') : null
          }
          if (val.type === 'textarea') {
            this.cusomerUpdate['fields'][val.key] = val.value
          }

          if (this.infoChange.fields && this.infoChange.fields.length > 0 && this.infoChange.fields !== null) {
            this.infoChange.fields.map((item) => {
              if (item.key === val.key) {

                if (val.type === 'date') {

                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdate['fields'][val.key] = {}
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                } else if (val.type === 'image') {
                  this.imagesFields[val.key] = item.string_values
                  // this.cusomerUpdate['fields'][val.key] = item.string_values
                } else {
                  this.cusomerUpdate['fields'][val.key] = item.string_values
                }
              }
            })
          }
        })
        console.log('this.cusomerUpdate', this.cusomerUpdate)
      }

    });
  }

  submitForm() {
    $('.submitForm').click()
  }

  public errStampBoxStampAlertAdd: any = '';

  excecuteGravity() {
    this.errStampBoxStampAlertAdd = ''
    let request: any = {
      customer: {},
    };
    console.log('this.status', this.status)
    // return;
    switch (this.status) {
      case 1: {
        this.isActiving = true;
        setTimeout(() => {
          this.isActiving = false;
        }, 2000);
        request.status = 1;
        request.serial_id = this.serial_input.trim();
        if (!this.infoActive.phone || this.infoActive.phone == '') {
          $('#phoneValidate').text('* Số điện thoại không được để trống');
        } else {
          request.customer.phone = this.infoActive.phone;
          $('#phoneValidate').text('');
        }

        if (!this.infoActive.name || this.infoActive.name == '') {
          $('#nameValidate').text('* Tên khách hàng không được để trống');
        } else {
          request.customer.name = this.infoActive.name;
          $('#nameValidate').text('');
        }

        if (this.infoActive.email && this.infoActive.email != '') {
          request.customer.email = this.infoActive.email;
        }
        if (this.infoActive.address && this.infoActive.address != '') {
          request.customer.address = this.infoActive.address;
        }
        if (this.infoActive.city && this.infoActive.city != '') {
          request.customer.city = parseInt(this.infoActive.city);
        }
        if (this.infoActive.district && this.infoActive.district != '') {
          request.customer.district = parseInt(this.infoActive.district);
        }
        if (this.variantId) {
          request.variant_id = this.variantId;
        }
        if (this.infoActive.product_code) {
          request.product_code = this.infoActive.product_code;
        }
        const fieldsData = {}
        for (const val in this.imagesFields) {
          // console.log(`${val}: ${this.imagesFields[val]}`);
          this.cusomerUpdate['fields'][val] = this.imagesFields[val];
        }
        console.log('vao ko >>', this.listRequire)
        console.log('this.typeField[property]', this.typeField)
        console.log('this.cusomerUpdate[property]', this.cusomerUpdate['fields'])
        for (const property in this.cusomerUpdate['fields']) {
          if (this.typeField[property] === 'select') {
            console.log('vao select  ko')
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && this.cusomerUpdate['fields'][property] === '-1') {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          } else if (this.typeField[property] === 'image') {
            console.log('vao select  image')
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          } else if (this.typeField[property] === 'checkbox') {
            console.log('vao select  checkbox')
            let arr = []
            for (const val in this.cusomerUpdate['fields'][property]) {
              if (typeof this.cusomerUpdate['fields'][property][val] === 'boolean') {
                if (this.cusomerUpdate['fields'][property][val]) {
                  let split = val.split('check')[1]
                  arr.push(split)
                }
              } else {
                arr.push(this.cusomerUpdate['fields'][property][val])
              }
            }
            fieldsData[property] = arr.join(',')
            console.log('fieldsDataSubmit', fieldsData[property])
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              console.log('tuanssss', this.listRequire.includes(property));
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return
            }
          }
          // tslint:disable-next-line:one-line
          else if (this.typeField[property] === 'date') {
            console.log('this.cusomerUpdate.date[property]', this.cusomerUpdate['fields'][property])
            if (this.cusomerUpdate['fields'][property]) {
              let dataDate = this.cusomerUpdate['fields'][property]
              if (dataDate) {
                if (typeof this.cusomerUpdate['fields'][property] === 'object') {
                  dataDate = moment(this.cusomerUpdate['fields'][property]).format('DD/MM/YYYY')
                }
                const date = dataDate.split('/')
                const dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
                fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
              }
            }
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;

            }
          } else if (this.typeField[property] === 'input') {
            console.log('vao select  input')
            console.log('this.cusomerUpdate.inputs[property]', this.cusomerUpdate['fields'][property])
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          } else {
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          }
        }
        request.customer.fields = fieldsData
        if (
          request.customer.phone &&
          request.customer.phone !== '' &&
          request.customer.name &&
          request.customer.name !== ''
        ) {
          console.log('tuanbabababaa')
          this.stampService
            .activeGuarantee(request)
            .toPromise()
            .then((res: any) => {
              if (res.code === 1) {
                this.toastr.success(
                  `<div>Thành công: <b>${res.data.totalSuccess}</b>, Thất bại: <b>${res.data.totalFailure}</b></div>`,
                  'Kích hoạt thành công',
                  {
                    timeOut: 5000,
                    positionClass: 'toast-bottom-right',
                    enableHtml: true,
                  }
                );
                this.isActiving = false;
                this.backToList.emit({
                  isBack: false,
                });
              } else if (res.code === 1800) {
                this.errStampBoxStampAlertAdd = res.message;
                $('.stampBoxStampAlertAdd').css('opacity', '1');
                setTimeout(() => {
                  this.isActiving = false;
                  this.backToList.emit({
                    isBack: false,
                  });
                  $('.stampBoxStampAlertAdd').css('opacity', '0');
                }, 5000)
                // this.toastr.warning(
                //   `Tem thùng đang được kích hoạt bảo hành, xin vui lòng chờ trong giây lát`,
                //   '',
                //   {
                //     timeOut: 7000,
                //     positionClass: 'toast-bottom-right',
                //     enableHtml: true,
                //   }
                // );
                // this.isActiving = false;
                // this.backToList.emit({
                //   isBack: false,
                // });
              } else {
                console.log('ngan2')
                this.toastr.error(
                  res.message || 'Kích hoạt thất bại',
                  'Thất bại',
                  {
                    timeOut: 5000,
                    positionClass: 'toast-bottom-right',
                    enableHtml: true,
                  }
                );
                EvsErr.evs_err(res, false);
              }
            })
            .catch((err: any) => {
              this.errStampBoxStampAlertAdd = err.message;
              $('.stampBoxStampAlertAdd').css('opacity', '1');
              // this.toastr.warning(err.message, '', {
              //   timeOut: 7000,
              //   positionClass: 'toast-bottom-right',
              // });

              setTimeout(() => {
                this.isActiving = false;
                this.backToList.emit({
                  isBack: false,
                });
                $('.stampBoxStampAlertAdd').css('opacity', '0');
              }, 5000);
            });
        }
        break;
      }
      case 2: {
        break;
      }
      case 5: {
        this.isChanging = true;
        setTimeout(() => {
          this.isChanging = false;
        }, 2000);
        request.status = 5;
        request.serial_id = this.serial_input.trim();
        if (!this.infoChange.phone || this.infoChange.phone == '') {
          $('#phoneValidate').text('* Số điện thoại không được để trống');
        } else {
          request.customer.phone = this.infoChange.phone;
          $('#phoneValidate').text('');
        }

        if (!this.infoChange.name || this.infoChange.name == '') {
          $('#nameValidate').text('* Tên khách hàng không được để trống');
        } else {
          request.customer.name = this.infoChange.name;
          $('#nameValidate').text('');
        }

        if (this.infoChange.email && this.infoChange.email != '') {
          request.customer.email = this.infoChange.email;
        }
        if (this.infoChange.address && this.infoChange.address != '') {
          request.customer.address = this.infoChange.address;
        }
        if (this.infoChange.city && this.infoChange.city != '') {
          request.customer.city = parseInt(this.infoChange.city);
        }
        if (this.infoChange.district && this.infoChange.district != '') {
          request.customer.district = parseInt(this.infoChange.district);
        }

        if (this.variantId) {
          request.variant_id = this.variantId;
        }


        let fieldsData = {}
        console.log('vao ko 111', this.cusomerUpdate['fields'])
        for (const val in this.imagesFields) {
          console.log(`${val}: ${this.imagesFields[val]}`);
          this.cusomerUpdate['fields'][val] = this.imagesFields[val];
        }

        console.log('vao ko 222', this.cusomerUpdate['fields'])

        for (const property in this.cusomerUpdate['fields']) {
          if (this.typeField[property] === 'select' && this.listRequire.includes(property) && this.cusomerUpdate['fields'][property] === '-1') {
            this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            return;
          }
          if (this.typeField[property] === 'select') {
            console.log('vao select  ko')
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && this.cusomerUpdate['fields'][property] === '-1') {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          } else if (this.typeField[property] === 'image') {
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          } else if (this.typeField[property] === 'checkbox') {
            let arr = []
            for (const val in this.cusomerUpdate['fields'][property]) {
              if (typeof this.cusomerUpdate['fields'][property][val] === 'boolean') {
                if (this.cusomerUpdate['fields'][property][val]) {
                  let split = val.split('check')[1]
                  arr.push(split)
                }
              } else {
                arr.push(this.cusomerUpdate['fields'][property][val])
              }

            }
            fieldsData[property] = arr.join(',')
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;

            }
          } else if (this.typeField[property] === 'date') {
            console.log('this.cusomerUpdate.fields[property]', this.cusomerUpdate['fields'][property])
            if (this.cusomerUpdate['fields'][property]) {
              let dataDate = this.cusomerUpdate['fields'][property]
              if (typeof this.cusomerUpdate['fields'][property] === 'object') {
                dataDate = moment(this.cusomerUpdate['fields'][property]).format('DD/MM/YYYY')
              }
              let date = dataDate.split('/')
              let dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
              fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
            }
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          } else {
            fieldsData[property] = this.cusomerUpdate['fields'][property]
            if (this.listRequire.includes(property) && !fieldsData[property]) {
              this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              return;
            }
          }

        }

        // body.fields = fieldsData
        console.log('fieldsData', fieldsData)
        // console.log(this.cusomerUpdate);
        request.customer.fields = fieldsData


        if (
          request.customer.phone &&
          request.customer.phone !== '' &&
          request.customer.name &&
          request.customer.name !== ''
        ) {
          this.stampService
            .logGuarantee(request)
            .toPromise()
            .then((res: any) => {
              console.log(res);
              if (res.status == 200) {
                this.toastr.success(
                  this.translate.instant('THAY_DOI_THONG_TIN_BH_THANH_CONG'),
                  '',
                  {
                    timeOut: 5000,
                    positionClass: 'toast-bottom-right',
                  }
                );
                this.isChanging = false;
                this.setInfoAfterUpdate();
                this.choiceReceive();
                this.modalRefCustomer.hide();
                if (this.productVariant) {
                  this.productVariant.id = this.tmpVariant
                    ? this.tmpVariant.id
                    : null;
                  this.productVariant.extra = this.tmpVariant
                    ? this.tmpVariant.extra
                    : null;
                }

                this.status = 2;
                // this.backToList.emit({
                //     isBack: false
                // })
              } else {
                EvsErr.evs_err(res, false);
                this.status = 2;
              }
              this.checkSerial();

            })
            .catch((err: any) => {
              this.status = 2;
              console.log(err);
              if (typeof err.message == 'object') {
                this.toastr.error(err.message.message, '', {
                  timeOut: 5000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.toastr.error(err.message, '', {
                  timeOut: 5000,
                  positionClass: 'toast-bottom-right',
                });
              }
            });
        } else {
          this.status = 2;
        }
        break;
      }
    }
  }

  updateCustomerInfo(data) {
    console.log(111);
    this.status = 5;
    this.isShowUpdateInfo = true;
    this.excecute();
  }

  setInfoAfterUpdate() {
    this.infoReceive.phone = this.infoChange.phone;
    this.infoReceive.name = this.infoChange.name;
    this.infoReceive.email = this.infoChange.email;
    this.infoReceive.city = this.infoChange.city;
    this.infoReceive.district = this.infoChange.district;
    this.infoReceive.address = this.infoChange.address;
  }

  updateStatus(status) {
    let statusString = '';
    switch (status) {
      case 3: {
        statusString = 'hoàn thành bảo hành';
        break;
      }
      case 4: {
        statusString = 'từ chối bảo hành';
        break;
      }
    }
    this.confirmationService.confirm({
      message:
        this.translate.instant('BAN_CHAC_CHAN_MUUON_CHUYEN_SANG') + ' ' +
        statusString +
        ' không ?',
      header: 'Xác nhận',
      icon: '',
      accept: () => {
        return;
        this.stampService
          .updateGuaranteeStatusById(this.log.id, status)
          .subscribe((res) => {
            if (!res.error) {
              this.toastr.info(
                this.translate.instant('DA_CHUYEN_TRANG_THAI_SANG') + ' ' + statusString,
                '',
                {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                }
              );
              this.status = 0;
              this.infoReceive = {};
              this.selectedStore = '';
              this.checkSerial();
            }
          });
      },
    });
  }

  /*Chinhpv*/
  // tslint:disable-next-line:member-ordering
  selectedCityId
  // tslint:disable-next-line:member-ordering
  selectedDistrictId
  // tslint:disable-next-line:member-ordering
  selectedStoreId;

  getIdCity() {
    if (this.check_list_store.length === 1 && this.flagCheckStoreList === 0) {
      this.selectedCityId = this.check_list_store[0].province.toString()
      this.selectedDistrictId = this.check_list_store[0].district.toString()
      this.selectedStoreId = this.check_list_store[0].value.toString()
      // console.log('idCit1111y', this.selectedCityId, this.selectedDistrictId, this.selectedStoreId);
      this.getListDistrict(this.selectedCityId, this.selectedDistrictId, 1);
      this.getIdDistrict();
      // this.getStoreFirst();
      this.flagCheckStoreList = 1;
    } else {
      this.getListDistrict(this.selectedCityId, null, 1);
    }
  }

  getIdDistrict() {
    console.log('idDistrict', this.selectedDistrictId);
    console.log('idCity', this.selectedCityId);
    this.selectedStoreId = '';
    this.getListStore(this.selectedCityId, this.selectedDistrictId);
  }

  /*End chinhpv*/

  // xử lý ảnh tiếp nhận bảo hành
  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error(this.translate.instant('CHI_DUOC_UPLOAD_5_ANH'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.images.length >= 5) {
              this.toastr.error(this.translate.instant('CHI_DUOC_UPLOAD_5_ANH'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.images.push(image2);
            }
          }
        });
      }
    }
  };
  tusUploadFields = (item, fieldKey) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error(this.translate.instant('CHI_DUOC_UPLOAD_5_ANH'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = res.data.url;
            if (this.imagesFields[fieldKey].length >= 5) {
              this.toastr.error(this.translate.instant('CHI_DUOC_UPLOAD_5_ANH'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesFields[fieldKey].push(image2);
            }


          }
        });
      }
    }
  };

  /*Ham xoa anh*/
  deleteImage(id) {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].id === id) {
        this.images.splice(this.images.indexOf(this.images[i]), 1);
        break;
      }
    }
  }

  deleteImageFields(id, fieldKey) {
    for (let i = 0; i < this.imagesFields[fieldKey].length; i++) {
      if (this.imagesFields[fieldKey][i].id === id) {
        this.imagesFields[fieldKey].splice(this.imagesFields[fieldKey].indexOf(this.imagesFields[fieldKey][i]), 1);
        break;
      }
    }
  }

  status_guarantee: any = null;
  guarantee_note: string = '';
  guarantee_title_dialog: string = '';

  showBasicDialog(status) {
    switch (status) {
      case 3: {
        this.guarantee_title_dialog = 'hoàn thành bảo hành';
        this.status_guarantee = 3;
        break;
      }
      case 4: {
        this.guarantee_title_dialog = 'từ chối bảo hành';
        this.status_guarantee = 4;
        break;
      }
    }
    this.displayBasic = true;
  }

  updateStatus_1(status) {
    this.stampService
      .updateGuaranteeStatusById(this.log.id, status, this.log)
      .subscribe((res) => {
        this.toastr.info(
          this.translate.instant('DA_CHUYEN_TRANG_THAI_SANG') + ' ' + this.guarantee_title_dialog,
          '',
          {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          }
        );
        this.status = 0;
        this.infoReceive = {};
        this.selectedStore = '';
        this.checkSerial();
        this.displayBasic = false;
        this.router.navigate(['/evs/guarantee/logs']);
      });
  }

  formatKey(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau

    str = str.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    str = str.replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      ' '
    );
    str = str.replace(/ + /g, ' ');
    str = str.replace(/\s/g, '');
    return str;
  }

  formatSerial(number, prefix: string = '') {
    let format_serial: string;
    let prefix2 = prefix ? prefix + '-' : '';
    number = number.toString();
    if (number.length > 6) {
      format_serial = prefix2 + number;
    } else {
      let pad = '000000';
      format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
    }
    return format_serial;
  }

  formatSerialNew(idStart, idEnd, prefix: string = '') {
    let format_serial: string;
    let prefix2 = prefix ? prefix + '-' : '';
    console.log('idStart.length:', idStart.toString().length);
    let pad = '000000'
    if (idStart === idEnd) {
      format_serial = prefix2 + pad.substring(0, 6 - idStart.toString().length) + idStart;
    } else {
      format_serial = prefix2 + pad.substring(0, 6 - idStart.toString().length) + idStart + ' --> ' + pad.substring(0, 6 - idEnd.toString().length) + idEnd;
    }
    return format_serial;
  }

  keyPressEvent(event: KeyboardEvent) {
    const specialChars = /[~`!@#$%^&*()_\-=\[\]{};':"\\|,.<>\/?A-Za-zÀ-Ỹà-ỹĂ-Ẽă-ẽẮ-Ỷắ-ỷĂ-Ỵă-ỵÂ-Ỹâ-ỹĐđÊ-Ỹê-ỹÔ-Ỷô-ỷƠ-Ỵơ-ỵƯ-Ỷư-ỷ\s]/
    const inputChar = String.fromCharCode(event.charCode);
    if (specialChars.test(inputChar)) {
      console.log('abc+')
      event.preventDefault();
      return;
    }
  }

  isNumber(value: string) {
    return /^[0-9 +]+$/.test(value)
  }

  onPasteEvent(event) {
    if (this.isNumber(event.target.value)) {
      event.preventDefault();
      return
    }
    const regex = /[~`!@#$%^&*()_\-=\[\]{};':"\\|,.<>\/?A-Za-zÀ-Ỹà-ỹĂ-Ẽă-ẽẮ-Ỷắ-ỷĂ-Ỵă-ỵÂ-Ỹâ-ỹĐđÊ-Ỹê-ỹÔ-Ỷô-ỷƠ-Ỵơ-ỵƯ-Ỷư-ỷ\s]/
    event.preventDefault();
    return regex.test(event.target.value) ? '' : event
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/active-guarantee.component.ts